module.exports = __webpack_public_path__ + "img/affiliate-desktop.b290c28.png";